import LayoutSetLevelZero from 'components/ui/layout-set/general/layout-set-level-zero';

import PageDashboard from 'components/pages/professional/home/page-dashboard';
import DashboardSettings from 'components/pages/professional/home/cmpt-dashboard-settings';

// import { SCOPES } from 'constants/roles';

// const auth = {
//   roles: SCOPES.STAFF,
//   redirect: { name: 'professional-login' },
//   forbiddenRedirect: { name: 'professional-forbidden' },
// };

export default [
  {
    path: '/professional/home',
    component: LayoutSetLevelZero,
    meta: {
      auth: true,
    },
    children: [
      {
        path: '',
        name: 'professional-home',
        components: {
          default: PageDashboard,
          collapsedMenuTop: DashboardSettings,
        },
        meta: {
          auth: true,
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/professional/home/index.js